import { createAction, props } from "@ngrx/store";
import { FoldFirebaseResponse } from "../../models/folds.model";
import { User } from "../../models/user.model";

export const LOAD_FOLD = '[Fold] Load fold';
export const LOAD_FOLD_SUCCESS = '[Fold] Load fold success';
export const LOAD_FOLD_FAIL = '[Fold] Load fold fail';
export const ADD_FOLD = '[Fold] Add fold';
export const ADD_FOLD_SUCCESS = '[Fold] Add fold success';
export const ADD_FOLD_FAIL = '[Fold] Add fold fail';
export const UPDATE_FOLD = '[Fold] Update fold';
export const UPDATE_FOLD_SUCCESS = '[Fold] Update fold success';
export const UPDATE_FOLD_FAIL = '[Fold] Update fold fail';

export const LoadFoldAction = createAction(
    LOAD_FOLD,
    props<{ data: User }>()
);

export const LoadFoldSuccessAction = createAction(
    LOAD_FOLD_SUCCESS,
    props<{ data: FoldFirebaseResponse }>()
);

export const LoadFoldFailAction = createAction(
    LOAD_FOLD_FAIL,
    props<{ error: Error }>()
);

export const AddFoldAction = createAction(
    ADD_FOLD,
    props<{ data: FoldFirebaseResponse; user: User }>()
);

export const AddFoldSuccessAction = createAction(
    ADD_FOLD_SUCCESS,
    props<{ data: FoldFirebaseResponse }>()
);

export const AddFoldFailAction = createAction(
    ADD_FOLD_FAIL,
    props<{ error: Error }>()
);

export const UpdateFoldAction = createAction(
    UPDATE_FOLD,
    props<{ data: FoldFirebaseResponse; user: User }>()
);

export const UpdateFoldSuccessAction = createAction(
    UPDATE_FOLD_SUCCESS,
    props<{ data: FoldFirebaseResponse }>()
);

export const UpdateFoldFailAction = createAction(
    UPDATE_FOLD_FAIL,
    props<{ error: Error }>()
);
